export function slips(
  state = {
    slipId: null,
    slips: {},
    currentSlip: {},
    updated: false,
    currentEcon: [],
  },
  action
) {
  switch (action.type) {
    case 'PUT_SLIP_STATE_START':
      return {
        ...state,
        slipId: null,
      };
    case 'PUT_SLIP_STATE_DONE':
      return {
        ...state,
        slipId: action.slipId,
      };
    case 'GET_ALL_SLIPS_START':
      return {
        ...state,
        slips: {},
      };
    case 'GET_ALL_SLIPS_DONE':
      return {
        ...state,
        slips: action.slips,
      };
    case 'GET_SLIP_START':
      return {
        ...state,
        currentSlip: {},
      };

    case 'GET_SLIP_DONE':
      return {
        ...state,
        currentSlip: action.currentSlip,
      };

    case 'GET_ECONOMIES_START':
      return {
        ...state,
        currentEcon: [],
      };

    case 'GET_ECONOMIES_DONE':
      return {
        ...state,
        currentEcon: action.currentEcon,
      };
    case 'RATE_SLIP_DONE':
      return {
        ...state,
        updated: true,
      };
    case 'RATE_SLIP_UPDATED_RESET':
      return {
        ...state,
        updated: false,
      };

    default:
      return state;
  }
}
